import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRouteMiddleware from 'vue-route-middleware'

import authenticated from './middleware/authenticated'
import admin from './middleware/admin'

Vue.use(VueRouter)

const appStartRoute = 'Dashboard'

// Routes mirror the compiled production app (dbi-research-production):
//   /login /logout / /support /exportData
//   /:projectSlug/checkin[/:patientId[/screening/:visitNumber?
//                                     |/visit/:visitNumber/:chapter?
//                                     |/upload/:visitNumber]]
const routes = [
  { path: '/login', name: 'Login', component: () => import('views/Login.vue') },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('views/Logout.vue'),
  },

  {
    path: '/',
    name: 'Dashboard',
    component: () => import('views/Dashboard.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/data',
    name: 'DataManagement',
    component: () => import('views/DataManagement.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/audit',
    name: 'AuditLog',
    component: () => import('views/AuditLog.vue'),
    meta: { middleware: [authenticated, admin] },
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: () => import('views/UserManagement.vue'),
    meta: { middleware: [authenticated, admin] },
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('views/Support.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('views/Settings.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/exportData',
    name: 'ExportData',
    component: () => import('views/Export.vue'),
    meta: { middleware: [authenticated] },
  },

  {
    path: '/:projectSlug/checkin',
    name: 'PatientCheckIn',
    component: () => import('views/CheckIn.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/:projectSlug/checkin/:patientId',
    name: 'PatientOverview',
    component: () => import('views/PatientOverview.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/:projectSlug/checkin/:patientId/screening/:visitNumber?',
    name: 'Screening',
    component: () => import('views/forms/Screening.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/:projectSlug/checkin/:patientId/visit/:visitNumber/:chapter?',
    name: 'Visit',
    component: () => import('views/forms/Visit.vue'),
    meta: { middleware: [authenticated] },
  },
  {
    path: '/:projectSlug/checkin/:patientId/upload/:visitNumber',
    name: 'Upload',
    component: () => import('views/forms/Upload.vue'),
    meta: { middleware: [authenticated] },
  },

  {
    path: '*',
    name: 'NotFound',
    component: () => import('views/NotFound.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

// vue-route-middleware runs each route's meta.middleware (e.g. authenticated).
router.beforeEach(VueRouteMiddleware())

export { router, appStartRoute }
export default router
